import { Product, ProductCode, BillingPlan, PaymentProviderPayload } from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';

import { request } from './request';

export const getProductsList = (): AxiosPromise<Product[]> => {
    const { Products } = request();

    return Products.productGet();
};

export const getBillingPlanList = (productCode: ProductCode): AxiosPromise<BillingPlan[]> => {
    const { Products } = request();
    return Products.productByCodeGet(productCode);
};

export const changeProductPost = (paymentProviderPayload: PaymentProviderPayload): Promise<string> => {
    const { Payments } = request();
    return Payments.paymentsPost(paymentProviderPayload).then((resp) => resp.data);
};
